import React, { Component } from 'react';
import axios from 'axios'
import { serverIp } from '../../../../config/constants'
import { Form, Segment, Button, Divider, } from 'semantic-ui-react'
import Select from 'react-select';
import * as UiConsts from '../../../../config/UiConstants';

import { getOrderNumberAndUpdateCounterNew } from '../../../../Utilities/FireBaseUtils';
import { getOrderNumberAndSaveOrder } from '../../../newSite/SaveOrderFunction/SaveOrderFunction';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

class CreateOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            orderStatuses: [],
            status: ''
        }
    }

    componentDidMount() {
        console.log("++++++++:componentDidMount");
    }



    createOrder = () => {
        console.log("cox1 ++++++++:updateStatus");
        console.log("cox12 this.props.largeProjectItemId:" + this.props.largeProjectItemId)
        console.log("cox13 this.props.user.email:" + this.props.user.email)
        console.log("cox14 item:" + JSON.stringify(this.props.item, null, 3));

        if (!this.props.largeProjectItemId) {
            alert("No largeProjectItemId")
        } else if (!this.props.user.email) {
            alert("No Entered By Provided")
        } else {
            console.log("cox14 sending data..");

           //let orderObject =  this.getNewOrderObjectForNewSaveFunction();

           getOrderNumberAndUpdateCounterNew(getOrderNumberAndSaveOrder, this.getNewOrderObjectForNewSaveFunction());

        }
    }

    /**
  * GET NEW ORDER OBJEC TO PASS TO SAVE FUNCTION..
  */
    getNewOrderObjectForNewSaveFunction() {
        console.log("cox21 ++++++++ - getNewOrderObjectForNewSaveFunction");

        let detailsString = 'This is a large project item:' + this.props.item.shirtType + ' for ' + this.props.item.project.name;
        console.log("cox22 detailsString:" + detailsString);

        let singleOrderArray = [];
        let singleOrderObject = {
            qty: "1",
            shirtColor: "check_project",
            shirtSize: "check_project",
            shirtText: "check_project",
            shirtType: this.props.item.shirtType
        }
        singleOrderArray.push(singleOrderObject);

        //orderObject.user && orderObject.user !== '' && orderObject.user.email)

        let user = {
            email: "biz@printboda.com"
        }
        
        let orderObject = {
            itemSelected: 'large_project_item',
            user: user,
            name: "<<PROJECT #"+this.props.item.project.idlargeProjects+" >>:"+this.props.item.project.name,
            admin: true,
            numOrders: 1,
            phone: this.props.item.project.largeProjectCustomer.phone1,
            phone2: this.props.item.project.salesPerson.phone,
            address: 'large project item',
            email: '',
            special_instructions: detailsString,
            adset: '',
            pricing_notes: detailsString,
            shirtSizeAndQtys: '',
            singleOrderArray: singleOrderArray,
            replacement: 'no',
            replacementReason: '',
            orderSource: 'large_project_item',
            bringJersey: '',
            orderType: 'large_project_item',
            gender: '',
            sendNewOrderSms: 'no',
            couponCode: '',
            salesPerson: this.props.item.project.salesPerson.name,
            sendDesignToSales: true,
            salesPerson_phone: this.props.item.project.salesPerson.phone,

            large_project_item: true,
            idlarge_project_item: this.props.item.largeProjectItemId,

            design_auto_sent: true,
        }

        // //set OrderType for Cranes / football
        // if (this.state.itemSelected === 'cranes') {
        //     orderObject.orderType = 'cranes'
        // } else if (this.state.itemSelected === 'football') {
        //     orderObject.orderType = 'football'
        // }

        // if (this.state.algoliaUser != '' && this.state.algoliaUser.sales) {
        //     console.log("sendDesignToSales13  algoliaUser sales is true:");

        //     orderObject.salesPerson = this.state.algoliaUser.normalName;
        //     console.log("sendDesignToSales15  orderObject.salesPerson:" + orderObject.salesPerson)

        //     orderObject.salesPerson_phone = this.state.algoliaUser.phone;
        //     console.log("sendDesignToSales15  orderObject.salesPerson_phone:" + orderObject.salesPerson_phone);

        //     if (this.state.sendDesignToSales) {
        //         console.log("sendDesignToSales1 is true:" + this.state.sendDesignToSales);

        //         orderObject.sendDesignToSales = true;
        //         console.log("sendDesignToSales15  orderObject.sendDesignToSales:" + orderObject.sendDesignToSales)


        //     } else {
        //         console.log("sendDesignToSales2 is false:" + this.state.sendDesignToSales);
        //         orderObject.sendDesignToSales = false;
        //     }

        // }

        console.log("cox23 new order object:" + JSON.stringify(orderObject, null, 3));
        return orderObject
    }

    render() {

        const setStatusButton = this.state.status != ''
            ? <Button onClick={this.updateStatus}>UPDATE STATUS</Button>
            : ''

        const enterPaymentDate =
            <div>
                <Divider horizontal>{'CREATE ORDER'}</Divider>

                <Button color='green' fluid onClick={this.createOrder}>CREATE ORDER</Button>
            </div>


        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>
            {enterPaymentDate}

        </div>);
    }
}

export default CreateOrder;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjectOrderEntry/CreateOrder.js